export const sumTotal = (documentos) => documentos.reduce((acc, documento) => acc + documento.total, 0);

export const calcAggregate = (documentos = []) => {
    const facturas = documentos.filter(d => d.tipo === "Factura");

    const totalFacturado = sumTotal(facturas);
    const contado = sumTotal(facturas.filter(d => d.terminos_pago === "Contado"));
    const contraEntrega = sumTotal(facturas.filter(d => d.terminos_pago.includes("contra")));

    return {
        recibos: sumTotal(documentos.filter(d => d.tipo === "Recibo")),
        facturas: sumTotal(facturas.filter(f => f.estado === "pagada" && f.tipo_pago !== "RI")),
        notaCreditos: sumTotal(documentos.filter(d => d.tipo === "Nota de crédito")),
        efectivo: sumTotal(documentos.filter(d => d.tipo_pago === "efectivo")),
        tarjeta: sumTotal(documentos.filter(d => ['tarjeta-debito', 'tarjeta'].includes(d.tipo_pago))),
        transferencia: sumTotal(documentos.filter(d => d.tipo_pago === "transferencia")),
        deposito: sumTotal(documentos.filter(d => d.tipo_pago === "deposito")),
        cheque: sumTotal(documentos.filter(d => d.tipo_pago === "cheque")),
        otro: sumTotal(documentos.filter(d => d.tipo_pago === "otro")),
        total_facturado: totalFacturado,
        contado,
        contra_entrega: contraEntrega,
        credito: totalFacturado - contado - contraEntrega,
    }
};